<template>
  <div class="page-wrap modify-grade">
    <div class="form-info" v-if="modifyInfo">
      <h1 class="title">{{ $t('report.confirmModificationResults') }}</h1>
      <a-row class="student-info">
        <a-col :span="8">
          {{ $t('public.name') }}{{ $t('public.colon')
          }}{{ modifyInfo.name }}&nbsp;
          {{ modifyInfo.surname }}
          {{ modifyInfo.givenName }}({{ modifyInfo.englishName }})
        </a-col>
        <a-col :span="8">
          {{ $t('public.studentId') }} {{ $t('public.colon') }}
          {{ modifyInfo.studentNo }}
        </a-col>
        <a-col :span="8">
          {{ $t('public.gender') }} {{ $t('public.colon') }}
          <a-icon
            v-if="!!modifyInfo.gender"
            :style="{
              fontSize: '20px',
              color: $utils.filteGender(modifyInfo.gender, 'color')
            }"
            :type="modifyInfo.gender | filteGender('icon')"
          />
        </a-col>
        <a-col :span="8">
          {{ $t('public.dateOfBirth') }} {{ $t('public.colon') }}
          {{ modifyInfo.birthdate }}
        </a-col>
        <a-col :span="8">
          {{ $t('public.enrollmentTime') }} {{ $t('public.colon') }}
          {{ modifyInfo.enrollDate }}
        </a-col>
        <a-col :span="8">
          {{ $t('public.enrollmentGradeTitle') }} {{ $t('public.colon') }}
          {{ modifyInfo.enrollGrade }}
        </a-col>
        <a-col :span="8">
          {{ $t('public.currentGrade') }} {{ $t('public.colon') }}
          {{ modifyInfo.currentGrade }}
        </a-col>
      </a-row>

      <div class="record" v-if="modifyStatus !== 'confirm'">
        <h2 class="record-title">
          {{ $t('report.currentGrade') }}
        </h2>
        <a-row class="record-info">
          <a-col :span="2" class="record-item-title">
            {{ $t('grades.participation') }}
          </a-col>
          <a-col :span="2" class="record-item-title">
            {{ $t('grades.assignments') }}
          </a-col>
          <a-col :span="2" class="record-item-title">
            {{ $t('grades.attendance') }}
          </a-col>
          <a-col :span="8" class="record-item-title">
            {{ $t('public.comments') }}
          </a-col>
          <a-col :span="4" class="record-item-title">
            {{ $t('public.editor') }}
          </a-col>
          <a-col :span="6" class="record-item-title">
            {{ $t('public.submitTime') }}
          </a-col>
          <a-col :span="2" class="record-item-info">
            {{
              currentRecord.recordStatus === 4
                ? 'N/A'
                : currentRecord.participation
            }}
          </a-col>
          <a-col :span="2" class="record-item-info">
            {{
              currentRecord.recordStatus === 4
                ? 'N/A'
                : currentRecord.assignments
            }}
          </a-col>
          <a-col :span="2" class="record-item-info">
            {{
              currentRecord.recordStatus === 4
                ? 'N/A'
                : currentRecord.attendance
            }}
          </a-col>
          <a-col :span="8" class="record-item-info">
            {{ currentRecord.comment }}
          </a-col>
          <a-col :span="4" class="record-item-info">
            {{ currentRecord.editor }}
          </a-col>
          <a-col :span="6" class="record-item-info">
            {{ currentRecord.createDate }}
          </a-col>
        </a-row>
      </div>

      <div class="record" v-if="modifyStatus !== 'turnDown'">
        <h2 class="record-title">
          {{
            modifyStatus === 'confirm'
              ? $t('report.currentGrade')
              : $t('report.modifiedScore')
          }}
        </h2>
        <a-row class="record-info">
          <a-col :span="2" class="record-item-title">
            {{ $t('grades.participation') }}
          </a-col>
          <a-col :span="2" class="record-item-title">
            {{ $t('grades.assignments') }}
          </a-col>
          <a-col :span="2" class="record-item-title">
            {{ $t('grades.attendance') }}
          </a-col>
          <a-col :span="8" class="record-item-title">
            {{ $t('public.comments') }}
          </a-col>
          <a-col :span="4" class="record-item-title">
            {{ $t('public.editor') }}
          </a-col>
          <a-col :span="6" class="record-item-title">
            {{ $t('public.submitTime') }}
          </a-col>
          <a-col :span="2" class="record-item-info">
            {{
              editorRecord.recordStatus === 4
                ? 'N/A'
                : editorRecord.participation
            }}
          </a-col>
          <a-col :span="2" class="record-item-info">
            {{
              editorRecord.recordStatus === 4 ? 'N/A' : editorRecord.assignments
            }}
          </a-col>
          <a-col :span="2" class="record-item-info">
            {{
              editorRecord.recordStatus === 4 ? 'N/A' : editorRecord.attendance
            }}
          </a-col>
          <a-col :span="8" class="record-item-info">
            {{ editorRecord.comment }}
          </a-col>
          <a-col :span="4" class="record-item-info">
            {{ editorRecord.editor }}
          </a-col>
          <a-col :span="6" class="record-item-info">
            {{ editorRecord.createDate }}
          </a-col>
        </a-row>
      </div>

      <div class="confirm-update" v-if="modifyStatus === ''">
        <a-button
          class="margin--right"
          :loading="loading"
          type="danger"
          @click="turnDownGrade"
        >
          {{ $t('handle.turnDown') }}
        </a-button>
        <a-button :loading="loading" type="primary" @click="confirmUpdateGrade">
          {{ $t('public.confirmModification') }}
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modifyId: undefined,

      studentId: undefined,
      weekId: undefined,
      courseId: undefined,
      academic: undefined,
      semester: undefined,

      modifyInfo: null,
      currentRecord: {},
      editorRecord: {},

      loading: false,
      // 操作状态
      modifyStatus: ''
    }
  },

  created() {
    this.getParams()
  },

  methods: {
    // 参数
    getParams() {
      const query = this.$route.query
      this.studentId = query.studentId
      this.weekId = query.weekId
      this.courseId = query.courseId
      this.academic = query.academic
      this.semester = query.semester
      this.modifyId = query.id
      this.getUpdateInfo()
    },

    // 修改的信息
    getUpdateInfo() {
      this.$http(this.$api.GETBASICTRANSCRIPTUPDATE, {
        studentId: this.studentId,
        weekId: this.weekId,
        courseId: this.courseId,
        academic: this.academic,
        semester: this.semester
      }).then(r => {
        if (r.data.length === 2) {
          this.modifyInfo = r.data[0].studentDTO || {}
          for (const item of r.data) {
            if (item.basicGradeStatus === 5) {
              this.currentRecord = Object.assign(this.currentRecord, item)
            } else {
              this.editorRecord = item
            }
          }
        } else {
          this.$router.push({ name: 'login' })
        }
      })
    },

    // 确认修改
    confirmUpdateGrade() {
      this.loading = true
      this.$http(
        this.$api.CONFIRMBASICTRANSCRIPTUPDATE,
        {
          id: this.modifyId
        },
        'get'
      ).then(() => {
        this.modifyStatus = 'confirm'
        this.$message.success(this.$t('public.saveSuccess'))
      })
    },

    // 驳回修改
    turnDownGrade() {
      this.loading = true
      this.$http(
        this.$api.TURNDOWNBASICTRANSCRIPTUPDATE,
        {
          id: this.modifyId
        },
        'get'
      ).then(() => {
        this.modifyStatus = 'turnDown'
        this.$message.success(this.$t('public.turnDownSuccessfully'))
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../style/variable.less';

.modify-grade {
  .form-info {
    border: 1px solid @lineColor;
    padding: 20px 40px;
    width: 900px;
    margin: 50px auto 0;
    .title {
      font-size: 20px;
      text-align: center;
    }
    .student-info {
      margin-top: 20px;
      & > div {
        margin: 5px 0;
      }
    }
    .record,
    .record {
      margin-top: 30px;
    }
    .record-title {
      font-size: 16px;
    }
    .record-info {
      margin-top: 10px;
    }
    .record-item-title {
      background-color: @backColor;
      line-height: 2.5;
      padding: 0 10px;
    }
    .record-item-info {
      line-height: 2.5;
      padding: 0 10px;
    }
    .confirm-update {
      display: flex;
      justify-content: flex-end;
      margin-top: 20px;
    }
  }
}
</style>
